import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';
import { categories } from '@app/src/views/Home/listProducts';
import {
  typeOperationReducer,
  typePropertyReducer,
  districtReducer,
  jobReducer,
  jobTopReducer,
  opportunityReducer,
  freeExtrachargeReducer,
  priceTotalReducer,
  typeVehicleReducer,
  modelVehicleReducer,
  brandVehicleReducer,
  brandVehicleTopReducer,
  yearVehicleReducer,
  adsRepublishReducer
} from '@app/src/views/StepOne/form';
import {
  typePublicationReducer,
  printReducer,
  vignetteReducer,
  extrachargeReducer,
  photoVignetteReducer,
  userMessageReducer
} from '@app/src/views/StepTwo/channelPublication';
import { modalError } from '@app/src/common/modalError';
import { calendarReducer } from '@app/src/common/datePicker/state/calendar';
import { summaryReducer, printConsumeReducer } from '@app/src/views/StepThree/publicationConfirmation';
import {
  dniReducer,
  rucReducer,
  priceReducer,
  paymentReducer,
  pricePackageReducer
} from '@app/src/views/StepPayment/formPayment';
import { flashMessageReducer } from '@app/src/common/flashMessageError';
import sessionReducer from '@app/src/common/session/state';
import { packageReducer } from '@app/src/views/Package/listPackage';
import { headBandReducer } from '@app/src/common/headBand';
import { breadCrumbReducer } from '@app/src/common/header';
import { myPackageAvailableReducer } from '@app/src/common/CounterAvailable';
import { announcementReducer, announcementDetailReducer } from '@app/src/views/MyAccount/listAvailable';
import { processConfirmReducer } from '@app/src/views/StepConfirm/sectionConfirm';
import { leadReducer } from '../common/formContact';

if (process.env.NODE_SSR) {
  global.window = {};
}

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      categories,
      typeOperation: typeOperationReducer,
      typeProperty: typePropertyReducer,
      typePublication: typePublicationReducer,
      district: districtReducer,
      print: printReducer,
      summary: summaryReducer,
      modalError,
      form: formReducer,
      calendar: calendarReducer,
      dni: dniReducer,
      ruc: rucReducer,
      price: priceReducer,
      payment: paymentReducer,
      job: jobReducer,
      jobTop: jobTopReducer,
      opportunity: opportunityReducer,
      freeExtracharge: freeExtrachargeReducer,
      vignette: vignetteReducer,
      extracharge: extrachargeReducer,
      priceTotal: priceTotalReducer,
      typeVehicle: typeVehicleReducer,
      modelVehicle: modelVehicleReducer,
      brandVehicle: brandVehicleReducer,
      brandVehicleTop: brandVehicleTopReducer,
      yearVehicle: yearVehicleReducer,
      flashMessage: flashMessageReducer,
      photoVignette: photoVignetteReducer,
      package: packageReducer,
      pricePackage: pricePackageReducer,
      headBand: headBandReducer,
      breadCrumb: breadCrumbReducer,
      myPackageAvailable: myPackageAvailableReducer,
      userMessage: userMessageReducer,
      printConsume: printConsumeReducer,
      announcement: announcementReducer,
      announcementDetail: announcementDetailReducer,
      adsRepublish: adsRepublishReducer,
      processConfirm: processConfirmReducer,
      session: sessionReducer,
      lead: leadReducer
    }),
    (window as any).__PRELOADED_STATE__,
    composeEnhancers(
      applyMiddleware(
        thunk,
      )
    )
  );
  return store;
}
